import { EProductTourTargets } from '@constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TitleWrapper, WidgetTitle, WidgetWrapper } from '../../../shared/WidgetShared.styles';

import { AllPlanification } from './components/AllPlanification';
import { CoursesPlanification } from './components/CoursesPlanification/CoursesPlanification';
import { StyledSegmented } from './ProgressWithPlanification.styles';

import { useMyPlanification, useMyPlanificationProgress } from '@/store';

export const ProgressWithPlanification = () => {
  const { planification } = useMyPlanification();
  const { planificationProgress, isPending } = useMyPlanificationProgress();
  const { t } = useTranslation('StudentDashboardTranslations');
  const [progressViewIsCourses, setProgressViewIsCourses] = useState(false);

  if (!planification || isPending) return null;
  if (!planificationProgress) return null;

  return (
    <WidgetWrapper id={EProductTourTargets.PROGRESS_WIDGET}>
      <TitleWrapper>
        <WidgetTitle>{progressViewIsCourses ? t('MY_PROGRESS') : t('PROGRESS')}</WidgetTitle>
        <StyledSegmented
          options={[
            { label: t('TOTAL'), value: false },
            { label: t('COURSES'), value: true }
          ]}
          value={progressViewIsCourses}
          onChange={value => setProgressViewIsCourses(value as boolean)}
          size="small"
        />
      </TitleWrapper>
      {progressViewIsCourses ? <CoursesPlanification /> : <AllPlanification />}
    </WidgetWrapper>
  );
};
